import { useMemo } from 'react';

const useUserProvider = (injectedProvider, localProvider) =>
  useMemo(() => {
    if (injectedProvider) {
      console.log('🦊 using injected provider');
      return injectedProvider;
    }
    // TODO:
    if (!localProvider) return undefined;
  }, [injectedProvider, localProvider]);

export default useUserProvider;
